import React from 'react';
import { Button, Divider } from 'antd';
import { ButtonGroup } from './style';
var preventDefault = function (e) { return e.preventDefault(); };
export var SelectDropdown = function (_a) {
    var menu = _a.menu, selectAll = _a.selectAll, reset = _a.reset;
    return (React.createElement("div", null,
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { size: "small", onMouseDown: preventDefault, onClick: selectAll, type: "link" }, "Select all"),
            React.createElement(Button, { size: "small", onMouseDown: preventDefault, onClick: reset, type: "link" }, "Reset")),
        React.createElement(Divider, { style: { margin: '4px 0' } }),
        menu));
};
//# sourceMappingURL=SelectDropdown.js.map